import * as React from "react";

import { SidebarProvider } from "../components/ui/sidebar";
import { AppSidebar } from "../components/system/app-sidebar";
import { Header } from "../components/system/header";

// TODO: remove these and replace with new alerts
import { AccountLimitAlerts } from "../shared-components/Alerts/AccountLimitAlert";
import { ApiTokenAlert } from "../shared-components/Alerts/ApiTokenAlert";
import { BannerAlerts } from "../shared-components/Banners/BannerAlerts";
import { UserSourceDialog } from "../shared-components/Dialogs/UserSourceDialog";
import { TrialExpirationAlert } from "../shared-components/Alerts/TrialExpirationAlert";

// TODO: remove this– it's old from the MUI implementation
export const drawerFullWidth = 240;

type Props = {
  children: any;
};

export const MainLayout: React.FC<Props> = ({ children }: Props) => {
  return (
    <SidebarProvider>
      <div className="grid grid-cols-[auto_1fr] min-h-screen w-full">
        <AppSidebar />
        <div className="min-w-0 flex flex-col">
          <Header />
          <main className="mt-14 flex-1">
            <div className="space-y-2 w-full">
              <UserSourceDialog />
              <AccountLimitAlerts />
              <ApiTokenAlert />
              <TrialExpirationAlert />
              <BannerAlerts />
              <div className="w-full">{children}</div>
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};
